import {extend, override} from 'flarum/common/extend';
import UserCard from 'flarum/forum/components/UserCard';
// import TypeFactory from './types/TypeFactory';

const inlinedFields = ['Telegram', 'WhatsApp', 'Facebook', 'Instagram', 'ВКонтакте', 'Linkedin', 'Skype'];
const typeUrlFactory = {
  'Telegram': (content) => `https://t.me/${content}`,
  'WhatsApp': (content) => `https://wa.me/${content}`,
  'Skype': (content) => `skype:${content}`,
};


const generateUrl = (type, content) => {
  const isKnownDataType = typeUrlFactory.hasOwnProperty(type);
  return isKnownDataType ? typeUrlFactory[type](content) : content;
}

export default function () {
  override(UserCard.prototype, 'infoItems', function (vdom) {
    let answers = app.forum.attribute('canViewMasquerade') ? this.attrs.user.bioFields() || [] : [];
    const items = vdom();
    // console.log(vdom());
    // hide dublicates
    // console.log(items.items['masquerade-bio'].content.children);
    items.items['masquerade-bio'].content.children
      .filter(el => !!el)
      .filter(el => inlinedFields.includes(el.children[0].children[1].children.trim().replace(':', '')))
      .forEach(el => el.attrs.style = {display: 'none'});
    items.replace('lastSeen', null, 101);
    const [joinedKey, joinedValue] = items.get('joined');
    items.replace('joined', <div className="--joined-user-params"><span>{joinedKey}</span><span>{joinedValue}</span></div>);


    items.add(
      'masquerade-bio2',
      m('div',
        answers.map((answer) => {
          const {name, icon} = answer.attribute('field');
          const matchedField = inlinedFields.includes(name);
          const content = answer.content().trim();

          if (matchedField && content.length > 0) {
            return <span style={{ marginRight: '12px', fontSize: '20px' }}>
              <a
                target="_blank"
                rel="noopener noreferrer"
                href={generateUrl(name, content)}><i className={icon}></i></a></span>
          }
        })
      )
    );

    return items;
  });
}

